import { Factory } from 'miragejs'
const faker = require('faker');
import { awardFactory } from './awardFactory';
import { campaignFactory } from './campaignFactory';
import { partnerFactory } from './partnerFactory';
import { coinFactory } from './coinFactory'
const randomRewardedUserValue = faker.datatype.number({ min: 1, max: 10 }) * 100


export default {
  award: awardFactory,
  campaign: campaignFactory,
  partner: partnerFactory,
  coin: coinFactory,
}



// WEBPACK FOOTER //
// ./src/mocks/factories/index.js